const en = {
  companyName: 'YOUNG SQUARE CREATECH',
  edit: 'Revise contact information',
  userTrackingAct: {
    description1: "Assist you to get business information",
    description2: "Exchange brand information on time",
    description3: "Demanded information automatically delivery to designate email daily",
    description4: "Easy to track and contact",
    description5: "Fill up contact information once",
    description6: "Digital brand information delivery",
    next: 'Next',
    next1: 'Next',
    declarationTitle: 'Personal Data Collection Agreement',
    declarationDetail1: 'In accordance with the provisions of the Personal Data Protection Act, we are legally obligated to inform you of the following:',
    declarationDetail2: 'By continuing your use of 1Click for the purpose of [',
    declarationDetail3: '], you agree to provide your [user data] to [',
    declarationDetail4: ']. The time period, recipients, territory, and methods of which the user data is used are explained by the [Privacy Notice] of [',
    declarationDetail5: ']. All collected user data will be limited to the use of the event, and compliant with the provisions of the Personal Data Protection Act to protect the user’s personal information.',
    termOfUse1: 'Agree',
    termOfUse2: 'the term of use',
    termOfUse3: 'This setting is required for further using of the service. If you do not agree the term, the service would not be provided.',
    termOfUse4: '',
    requestFor1: 'I would like to have booth information includes contact information, digital introduction, etc.',
    requestFor2: 'All the requesting data of booths would be deliver via email after 3  hours of the day you request.',
    confirm: 'Confirm',
    inputNotice: 'Fill out below informations to get business information and company contact info.',
    userName: 'Name',
    userNamePlaceHolder: 'Please input your name',
    userEmail: 'Email address',
    userEmailNotice: 'Please input your email to collect the event information',
    userEmailPlaceHolder: 'Please input your Email address',
    userPhone: 'Cellphone',
    userPhonePlaceHolder: 'Please input your cellphone number',
    userCompany: 'Company Name',
    userCompanyPlaceHolder: 'Please provide your company name',
    userJobTitle: 'Job Title',
    userJobTitlePlaceHolder: 'Please select your job function',
    userIndustry: 'Company / Organization Industry Segment',
    userIndustryPlaceHolder: 'Your type of business',
    back: 'Back',
  },
  userTrackingResult: {
    description1: 'Thank you for get interesting and will be connect with us. All your demanded digital informations such as EDM and company contact would deliver to your designated Email automatically on the date you visit.',
    openAttachment: 'Click to open the digital information of this booth/brand',
  },
  visitorReport: {
    description1: 'Hello, Thank you for using 1click-Digital Business Information at ',
    description2: ' , your requesting business informations and EDM was be listed in below link',
    description3: '',
    description4: ': The demanding brand information your require today',
    description5: 'Date: ',
    col1: 'Visited Time',
    col2: 'Company Name',
    col3: 'Contect Person',
    col4: 'Phone number',
    col5: 'E-Mail',
    col6: 'Digital Information',
    link: 'Link',
  },
  boothReport: {
    description1: ', thank you for using 1Click, please find below for the list of requesitng your business information',
    description2: '',
    description3: 'Visitor Lists',
    description4: 'Date: ',
    col1: 'Visiting Time',
    col2: 'Company Name',
    col3: 'Industry Type',
    col4: 'Name',
    col5: 'Job Title',
    col6: 'Phone Number',
    col7: 'Email Address',
  },
};

export default en;
